import {Directive, Input, ViewContainerRef} from '@angular/core';
import {LoadableComponent} from '../../_interface/loadableComponent';
import {ComponentLoaderService} from 'shared/_services/component-loader.service';

@Directive({
	selector: '[layoutAttach]'
})
export class AttachDirective {
	@Input() set layoutAttach(loadableComponent: LoadableComponent) {
		if (!loadableComponent) {
			this.viewContainerRef.clear();
			return;
		}
		this.compLoader.attachComponent(loadableComponent, this.viewContainerRef);
	}

	constructor(
		private viewContainerRef: ViewContainerRef,
		private compLoader: ComponentLoaderService
	) {}
}
